import SecretDialog from './src/secret-dialog';

export default SecretDialog;
